import React from 'react';
import { useLabels, useRequestData } from 'wsm-common-data';
import { Tiles } from 'wsm-tiles';
import { useBodystyleData } from '../hooks/useBodystyleData';
import MiniGridView from '../components/MiniGridView';
import { MOBILE } from '../global-constants';

const Widget = () => {
	const labels = useLabels();
	const requestData = useRequestData();
	const { bodystyleData, isReady, error } = useBodystyleData();
	const isMobile = requestData.deviceType === MOBILE;

	if (error) {
		return <div>{labels.get('ERROR_SOMETHING_WENT_WRONG')}</div>;
	}
	if (!isReady) {
		return <div>{labels.get('LOADING')}</div>;
	}
	// wsm-tiles still renders its (carousel) wrapper markup for an empty array,
	// so collapse the widget here rather than leaving empty section behind.
	if (!bodystyleData?.length) {
		return null;
	}

	// On mobile, show the mini-grid view.
	if (isMobile) {
		return <MiniGridView data={bodystyleData} />;
	}

	return (
		<Tiles
			type="bodystyle"
			data={bodystyleData}
			layout="carousel"
			className="py-3"
		/>
	);
};

export default Widget;
